module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNewEintrag = true) && (_vm.eintragIstNeu = true) && (_vm.neuerEintrag = {
                datum: _vm.heute
              })
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neuer Eintrag")])]), _vm._v("\n    " + _vm._s(_vm.kasse) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-list-item', {
    key: _vm.item
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Aktueller Kassenstand:")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.kasse))])], 1), _vm._v(" "), _c('v-list-item-action', {
    staticClass: "title pr-2 green--text"
  }, [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.summe)) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-virtual-scroll', {
    attrs: {
      "items": _vm.kassenbuch,
      "height": 590,
      "item-height": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          key: item.id,
          on: {
            "click": function($event) {
              return _vm.itembearbeiten(item)
            }
          }
        }, [_c('v-list-item-avatar', [(item.betrag < 1) ? _c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("upload")])], 1) : _c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('v-divider', {
          attrs: {
            "vertical": ""
          }
        }), _vm._v(" "), _c('v-list-item-content', {
          staticClass: "ml-4"
        }, [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.titel))])], 1), _vm._v(" "), _c('v-list-item-action', {
          staticClass: "subtitle-2 pr-2"
        }, [_vm._v("\n                " + _vm._s(_vm._f("money")(item.betrag)) + "\n              ")])], 1), _vm._v(" "), _c('v-divider')]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNewEintrag),
      callback: function($$v) {
        _vm.showNewEintrag = $$v
      },
      expression: "showNewEintrag"
    }
  }, [_c('v-card', [_c('v-card-title', [(_vm.eintragIstNeu) ? _c('div', [_vm._v("Eintrag hinzufügen")]) : _c('div', [_vm._v("Eintrag bearbeiten")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Titel",
      "outlined": ""
    },
    model: {
      value: (_vm.neuerEintrag.titel),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "titel", $$v)
      },
      expression: "neuerEintrag.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-2 py-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "number": "",
      "label": "Betrag",
      "outlined": ""
    },
    model: {
      value: (_vm.neuerEintrag.betrag),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "betrag", $$v)
      },
      expression: "neuerEintrag.betrag"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-menu', {
    ref: "neuerEintrag.datum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "hide-details": "",
            "outlined": "",
            "label": "Datum"
          },
          model: {
            value: (_vm.formatDatum),
            callback: function($$v) {
              _vm.formatDatum = $$v
            },
            expression: "formatDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.neuerEintrag.datum),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "datum", $$v)
      },
      expression: "neuerEintrag.datum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 py-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    staticClass: "red--text",
    attrs: {
      "hide-details": "",
      "disabled": "",
      "block": "",
      "height": "56",
      "outlined": ""
    }
  }, [_vm._v("Rechnung"), _c('br'), _vm._v("hochladen"), _c('v-icon', [_vm._v("upload")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "label": "Bemerkung",
      "outlined": ""
    },
    model: {
      value: (_vm.neuerEintrag.bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "bemerkung", $$v)
      },
      expression: "neuerEintrag.bemerkung"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.eintragIstNeu) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEintrag(_vm.neuerEintrag.id)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.eintragIstNeu) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNeuEintrag()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.saveEintrag(_vm.neuerEintrag)
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63664551"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/kassenbuch.vue
// module id = 785
// module chunks = 15